import { createContext, useContext } from 'react';
import { IFormTemplate } from './interfaces';

const FormContext = createContext<IFormTemplate>(undefined as unknown as IFormTemplate);

FormContext.displayName = 'FormContext';

export const useFormContext = (): IFormTemplate => {
  const value = useContext(FormContext);
  if (!value) {
    throw Error('FormContext is used without Provider');
  }

  return value;
};

export default FormContext;
